import clsx from 'clsx'
import type { ReactNode } from 'react'

/**
 * Breaks out of a max-width parent so background and width span the viewport;
 * inner content stays aligned with {@link ContentWrapper}.
 */
export function FullBleedBand({
  children,
  className,
  innerClassName,
}: {
  children: ReactNode
  className?: string
  innerClassName?: string
}) {
  return (
    <div
      className={clsx(
        'relative left-1/2 right-1/2 -ml-[50vw] -mr-[50vw] w-screen max-w-[100vw]',
        className
      )}
    >
      <div
        className={clsx(
          'mx-auto max-w-(--breakpoint-xl) px-4 xl:px-0',
          innerClassName
        )}
      >
        {children}
      </div>
    </div>
  )
}
